import { Apollo } from 'apollo-angular';
import { inject, Injectable } from '@angular/core';

import { Query } from './generated';

type QueryKey = Exclude<keyof Query, '__typename'>;

@Injectable()
export class ApolloService {
  public readonly apollo = inject(Apollo);
  public readonly client = this.apollo.client;
  public readonly cache = this.client.cache;

  public invalidate<TArgs extends Record<string, unknown> = Record<string, unknown>>(query: QueryKey, args?: Partial<TArgs>, withGC = true): boolean {
    const result = this.cache.evict({
      fieldName: query,
      args,
    });

    if (result && withGC) this.cache.gc();
    return result;
  }
}
